import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box, useTokens } from "@gemini/core";
import { FeedbackMessage } from "@gemini/ui";
import { useErrorTrackingView } from "@/hooks";
import { HttpStatus } from "@/constants";
import { SimilarListingSSR } from "@/components/SimilarListings/SimilarListingSSR";
import { SimilarProviderListings } from "./SimilarProviderListings/SimilarProviderListings";
import { useLastSearch } from "@/hooks/useLastSearch";
import { LastSearch } from "./LastSearch/LastSearch";
const getFeedbackTexts = (status) => {
    switch (status) {
        case HttpStatus.UNPUBLISHED:
            return {
                title: "errorpage.unpublished.feedback.title",
                message: "errorpage.unpublished.feedback.message",
            };
        case HttpStatus.DELETED:
            return {
                title: "errorpage.deleted.feedback.title",
                message: "errorpage.deleted.feedback.message",
            };
        case HttpStatus.BROKEN_LINK:
            return {
                title: "errorpage.broken_link.feedback.title",
                message: "errorpage.broken_link.feedback.message",
            };
        case HttpStatus.TECHNICAL_ERROR:
            return {
                title: "errorpage.technical_error.feedback.title",
                message: "errorpage.technical_error.feedback.message",
            };
        default:
            return {
                title: "errorpage.technical_error.feedback.title",
                message: "errorpage.technical_error.feedback.message",
            };
    }
};
export const ErrorPage = ({ code, status }) => {
    const tokens = useTokens();
    const { t } = useI18n();
    const headerHeight = tokens["sizing.64"]; // see https://github.com/axel-springer-kugawana/aviv_whitelabel_header_footer/blob/main/white-label/src/components/header/header.tsx
    const feedbackTexts = getFeedbackTexts(status);
    const lastSearch = useLastSearch();
    useErrorTrackingView(code);
    return (_jsx(Box, { minHeight: `calc(100vh - ${headerHeight})`, children: _jsxs(Box, { as: "main", position: "relative", display: "grid", gridTemplateColumns: {
                "breakpoint.base": "repeat(4, [col-start] 1fr)",
                "breakpoint.lg": "repeat(12, [col-start] 1fr)",
                "breakpoint.xl": "repeat(12, [col-start] 1fr)",
            }, gap: {
                "breakpoint.base": "spacing.16",
                "breakpoint.lg": "spacing.24",
            }, maxWidth: {
                "breakpoint.base": "1024px",
                "breakpoint.xl": "1280px",
                "breakpoint.xxl": "1536px",
                "breakpoint.xxxl": "1920px",
            }, paddingHorizontal: {
                "breakpoint.base": "0",
                "breakpoint.lg": "spacing.32",
                "breakpoint.xl": "spacing.80",
            }, marginHorizontal: {
                "breakpoint.lg": "auto",
            }, paddingTop: "spacing.48", marginBottom: "spacing.48", width: "100%", children: [_jsxs(Box, { as: "section", position: "relative", paddingHorizontal: "spacing.16", paddingVertical: "spacing.12", gridColumn: {
                        "breakpoint.base": "col-start / span 4",
                        "breakpoint.md": "col-start / span 4",
                        "breakpoint.lg": "col-start / span 12",
                        "breakpoint.sm": "col-start / span 8",
                        "breakpoint.xl": "col-start 1 / span 12",
                        "breakpoint.xxl": "col-start 2 / span 10",
                        "breakpoint.xxxl": "col-start 2 / span 10",
                    }, children: [_jsx(Box, { maxWidth: {
                                "breakpoint.lg": "70%",
                                "breakpoint.xl": "60%",
                                "breakpoint.xxl": "50%",
                                "breakpoint.base": "100%",
                            }, marginBottom: "spacing.40", marginHorizontal: {
                                "breakpoint.base": "unset",
                                "breakpoint.lg": "auto",
                            }, children: _jsx(FeedbackMessage, { variant: "warning", title: t(feedbackTexts.title), children: t(feedbackTexts.message) }) }), _jsx(Box, { display: "flex", flexDirection: "column", textAlign: "center", width: "100%", alignItems: {
                                "breakpoint.base": "center",
                                "breakpoint.lg": "unset",
                            }, backgroundColor: "color.background.default", borderRadius: "radius.8", boxShadow: "shadow.8", paddingHorizontal: {
                                "breakpoint.lg": "spacing.32",
                                "breakpoint.base": "spacing.16",
                            }, paddingVertical: "spacing.32", minHeight: {
                                "breakpoint.md": "168px",
                                "breakpoint.base": "281px",
                            }, maxWidth: {
                                "breakpoint.lg": "70%",
                                "breakpoint.xl": "60%",
                                "breakpoint.xxl": "50%",
                                "breakpoint.base": "100%",
                            }, marginHorizontal: {
                                "breakpoint.base": "unset",
                                "breakpoint.lg": "auto",
                            }, children: lastSearch === undefined ? null : _jsx(LastSearch, { status: status }) })] }), _jsx(SimilarListingSSR, {}), _jsx(SimilarProviderListings, {})] }) }));
};
